import { render } from "./SyntheseMenu.vue?vue&type=template&id=386077bc&scoped=true"
import script from "./SyntheseMenu.vue?vue&type=script&lang=ts"
export * from "./SyntheseMenu.vue?vue&type=script&lang=ts"

import "./SyntheseMenu.vue?vue&type=style&index=0&id=386077bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-386077bc"

export default script